import { CompanyId, CompanyName } from "helpers";
import { t } from "i18next";

interface RoleHeaderSelectCompanyProps {
  companyId: CompanyId;
  companyName: CompanyName;
  onOpenModal: () => void;
}
export const RoleHeaderSelectCompany = ({ companyId, companyName, onOpenModal }: RoleHeaderSelectCompanyProps) => (
  <div className="flex items-center justify-center gap-2">
    <div className="flex items-center gap-1">
      <span className="flex items-center whitespace-nowrap font-bold">{t("roleManagement.rolesForCompany")}:</span>
      <span className="flex items-center whitespace-nowrap font-normal">
        {companyId === "0" ? t("roleManagement.allCompanies") : companyName || companyId}
      </span>
    </div>
    <div className="flex items-center gap-1">
      <div className="flex gap-1">
        <span
          className="flex cursor-pointer items-center whitespace-nowrap text-sm font-normal hover:underline"
          onClick={() => onOpenModal()}
        >
          {t("roleManagement.change")}
        </span>
      </div>
    </div>
  </div>
);
